import { Link } from "react-router";

import { Icon } from "./Icon";

export interface Crumb {
  label: string;
  /** Where the crumb goes; the last crumb is the current page and is never a link. */
  to?: string;
}

/** "‹ Domains / example.com": a back chevron to the nearest linked crumb, then the trail. */
export function Breadcrumb({ items, backTo = "/" }: { items: Crumb[]; backTo?: string }) {
  const back = [...items].reverse().find((c) => c.to);
  return (
    <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-1 text-sm">
      <Link to={back?.to ?? backTo} aria-label="Back" className="flex items-center text-fg-subtle">
        <Icon name="chevron-left" size={16} />
      </Link>
      {items.map((c, i) => {
        const last = i === items.length - 1;
        return (
          <span key={`${c.label}-${i}`} className="flex items-center gap-1">
            {i > 0 && <span className="text-fg-subtle opacity-60">/</span>}
            {last ? (
              <span className="font-medium text-fg">{c.label}</span>
            ) : c.to ? (
              <Link to={c.to} className="text-fg-subtle hover:text-fg">
                {c.label}
              </Link>
            ) : (
              <span className="text-fg-subtle">{c.label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
